// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeepLinkViewAction__main-action-cfa90a {
  width: 100%;
}

.DeepLinkViewAction__content-aae4dc {
  display: flex;
  flex-direction: column;
  gap: 24px;
}`, "",{"version":3,"sources":["webpack://./src/pages/deepLink/DeepLinkViewAction/DeepLinkViewAction.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF","sourcesContent":[".main-action {\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-action": `DeepLinkViewAction__main-action-cfa90a`,
	"mainAction": `DeepLinkViewAction__main-action-cfa90a`,
	"content": `DeepLinkViewAction__content-aae4dc`
};
module.exports = ___CSS_LOADER_EXPORT___;
